import { api } from '@/config/api';

export type PlatformKeyGroup = 'ai' | 'voice' | 'whatsapp' | 'meta' | 'google' | 'tiktok' | 'x' | 'media';

export interface PlatformKeyRow {
  key: string;
  group: PlatformKeyGroup;
  label: string;
  isSecret: boolean;
  description?: string;
  test?: string;
  source: 'db' | 'env' | 'missing';
  /** Masked for secrets. */
  value: string | null;
  updatedAt?: string;
  disabled?: boolean;
  lastTestedAt?: string;
  lastTestResult?: 'ok' | 'failed';
}

const BASE = '/super_admin/platform-configs';

export const platformConfigsService = {
  list: async (): Promise<PlatformKeyRow[]> => (await api.get(BASE)).data,
  set: async (key: string, value: string): Promise<PlatformKeyRow> => (await api.put(`${BASE}/${key}`, { value })).data,
  setEnabled: async (key: string, enabled: boolean): Promise<PlatformKeyRow> => (await api.patch(`${BASE}/${key}/enabled`, { enabled })).data,
  unset: async (key: string): Promise<PlatformKeyRow> => (await api.delete(`${BASE}/${key}`)).data,
  test: async (key: string): Promise<{ ok: boolean; detail: string }> => (await api.post(`${BASE}/${key}/test`)).data,
};
